import EPricePeakItem from '../EpriceTime/PeakItem';
import React, { useEffect, useState } from 'react';
import { PricedisplayType, PricedisplayTypeDisplay, EPriceTime } from '@/shared/types';
import { Form, Radio, Select } from '@maxtropy/components';
import { getPeriodTime } from '../EpriceTime/utils';
import styles from './index.module.scss';
import { Space } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
interface IdExpriceTime {
  ids: string[];
  times: EPriceTime[];
  displayType?: PricedisplayType;
  initType?: PricedisplayType;
}
const TimeSelect: React.FC<{
  initExprieceTimeList?: IdExpriceTime;
  setEpr: React.Dispatch<React.SetStateAction<IdExpriceTime>>;
  disabledIntervals?: EPriceTime[];
}> = ({ initExprieceTimeList, setEpr, disabledIntervals }) => {
  console.log('dia', disabledIntervals);
  console.log('displayType', initExprieceTimeList?.displayType);
  const [displayType, setDisplayType] = useState<PricedisplayType>(
    initExprieceTimeList?.displayType || PricedisplayType.HALF
  );
  const [times, setTimes] = useState<EPriceTime[]>(initExprieceTimeList?.times || []);
  const [form] = Form.useForm();
  useEffect(() => {
    setEpr({ ids: initExprieceTimeList?.ids || [], times, displayType });
  }, [times, displayType]);
  useEffect(() => {
    setTimes(initExprieceTimeList?.times || []);
    setDisplayType(initExprieceTimeList?.displayType || PricedisplayType.HALF);
  }, [initExprieceTimeList?.times, initExprieceTimeList?.displayType]);

  return (
    <>
      {/* 可交互编辑模式 */}
      <Form form={form}>
        <Form.Item name="timeType" label="时间展示类型" rules={[{ required: true }]} initialValue={displayType}>
          <Radio.Group
            onChange={e => {
              setDisplayType(e.target.value);
              setTimes([]);
            }}
            value={displayType}
          >
            <Radio value={PricedisplayType.HALF}>
              {PricedisplayTypeDisplay[PricedisplayType.HALF]}展示(最小颗粒度30分钟)
            </Radio>
            <Radio value={PricedisplayType.HOUR}>
              {PricedisplayTypeDisplay[PricedisplayType.HOUR]}展示(最小颗粒度1小时)
            </Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item label="时间" name="timeRange" rules={[{ required: true }]}>
          <div style={{ marginRight: '72px' }}>
            <EPricePeakItem
              value={times}
              displayType={displayType}
              onChange={newTimes => {
                setTimes(newTimes);
              }}
              disabledIntervals={
                displayType === PricedisplayType.HOUR
                  ? disabledIntervals
                  : disabledIntervals?.map(item => ({
                      type: item.type,
                      intervalStart: item.intervalStart * 2,
                      intervalEnd: item.intervalEnd * 2 + 1,
                    }))
              }
            />
          </div>
          <Select
            mode="tags"
            showSearch={false}
            open={false}
            value={times.map(t => getPeriodTime(t, displayType))}
            className={styles['no-border-no-arrow']}
            style={{ marginLeft: '-5px' }}
            onChange={value => {
              setTimes(t => t.filter(item => value.includes(getPeriodTime(item, displayType))));
            }}
          />
          <div>
            <Space>
              <InfoCircleOutlined
                style={{ color: '#FAAD14' }}
                onPointerEnterCapture={undefined}
                onPointerLeaveCapture={undefined}
              />
              {`在时间轴上分别单击选择起止时间块`}
            </Space>
          </div>
        </Form.Item>
      </Form>
    </>
  );
};

export default TimeSelect;
